import { Autocomplete, Button, Paper, Text, Box, Flex, Group } from '@mantine/core'
import classes from './ManageProductsCategory.module.css'
import { IoAdd } from "react-icons/io5";
import { IoMdSearch } from "react-icons/io";
import React, { memo, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import Categorydatatable from './Categorydatatable';
import InputButton from '../../../CustomComponent/InputFileButton/Inputbutton.component';
import { baseUrl } from '../../../Constants/constant';
import SampleFile from '../../../CustomComponent/DownloadSampleFile/Samplefile.component';

const ManageProductCategory = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState<any>('');
  const [sendsearch, setSendsearch] = useState<any>('');

  const handlechange = (value: any) => {
    setSearch(value);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setSendsearch(search);
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);


  return (
    <>

      <Paper shadow="xs" p="xs" radius="md">
        <Box>
          <Flex
            style={{ justifyContent: 'space-between' }}
            align="center" >
            <Box>
              <Text ta="left">Sub Category</Text>
            </Box>
            <Group>
              <Autocomplete
                // label="Your favorite library"
                value={search}
                onChange={handlechange}
                placeholder="Search by Sub-category"
                leftSection={<IoMdSearch />}
              />

              <Button
                className={classes.addbtn}
                variant="gradient"
                gradient={{ from: '#404040', to: '#404040', deg: 90 }}
                leftSection={<IoAdd size={20} />}
                onClick={() => navigate('/manage-products-category/addcategory')}
              >
                Add Sub Category
              </Button>
                <InputButton url={`${baseUrl}admin/categories/import-file`} />
              <SampleFile type={'category'} />
            </Group>
          </Flex>
          <Categorydatatable editLink={'/manage-products-category/addcategory'} search={sendsearch} />
        </Box>
      </Paper>
    </>
  )
}

export default memo(ManageProductCategory)
